var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInituateChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3385 14.1667C18.3385 14.6087 18.1629 15.0326 17.8504 15.3452C17.5378 15.6577 17.1139 15.8333 16.6719 15.8333H5.69521C5.25322 15.8334 4.82936 16.0091 4.51687 16.3217L2.68187 18.1567C2.59913 18.2394 2.49371 18.2957 2.37895 18.3186C2.26419 18.3414 2.14523 18.3297 2.03713 18.2849C1.92903 18.2401 1.83663 18.1643 1.77161 18.067C1.7066 17.9697 1.67189 17.8553 1.67188 17.7383V4.16667C1.67187 3.72464 1.84747 3.30072 2.16003 2.98816C2.47259 2.67559 2.89651 2.5 3.33854 2.5H16.6719C17.1139 2.5 17.5378 2.67559 17.8504 2.98816C18.1629 3.30072 18.3385 3.72464 18.3385 4.16667V14.1667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66602V11.666",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16602H12.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInituateChat);
export default __webpack_public_path__ + "static/media/inituate-chat.916913b866ad45ccd808e1cb203ee87a.svg";
export { ForwardRef as ReactComponent };